module.exports = __webpack_public_path__ + "img/CRU.c8a33f33.jpg";